import { Box } from '@chakra-ui/react'
import { IconDefinition } from '@fortawesome/pro-regular-svg-icons'
import { ItListItemType } from 'types/graphql'

import { BrandColor } from 'src/types'

import Icon from './Icon/Icon'
import Image from './Image/Image'

const Thumbnail: React.FC<{
  coverUrl?: string
  type: ItListItemType
  url?: string
  brandColor: BrandColor
  fallbackIcon?: IconDefinition
}> = ({ coverUrl, type, url, brandColor, fallbackIcon }) => (
  <Box
    h="100%"
    filter="brightness(0.97)"
    overflow="clip"
    borderRadius={8}
    minW="100px"
    minH="100px"
    boxSizing="content-box"
    position="relative"
    alignSelf="flex-start"
  >
    <Image coverUrl={coverUrl} type={type} />
    <Icon url={url} brandColor={brandColor} fallbackIcon={fallbackIcon} />
  </Box>
)

export default Thumbnail
